import React from 'react';
import { Badge, Button } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const TYPE_LABEL = { deposit: 'إيداع', purchase: 'شراء', refund: 'استرجاع' };
const STATUS_COLOR = { pending: 'yellow', completed: 'green', failed: 'red' };
const STATUS_LABEL = { pending: 'قيد الانتظار', completed: 'مكتملة', failed: 'فشلت' };

const TransactionsTable = ({ data, page, handleUpdateStatus }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>المستخدم</th>
        <th>رقم العملية</th>
        <th>البريد الإلكتروني</th>
        <th>النوع</th>
        <th>المبلغ</th>
        <th>الحالة</th>
        <th>التاريخ</th>
        <th>الإجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((item, idx) => (
        <tr key={item._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{item.user?.name ?? '-'}</td>
          <td>{item._id}</td>
          <td>{item.user?.email ?? '-'}</td>
          <td>{TYPE_LABEL[item.type] ?? item.type}</td>
          <td>{item.amount} {item.currency}</td>
          <td><Badge colorScheme={STATUS_COLOR[item.status]}>{STATUS_LABEL[item.status] ?? item.status}</Badge></td>
          <td>{new Date(item.created_at).toLocaleDateString('ar-EG')}</td>
          <td>
            {item.status === 'pending' && (
              <>
                <Button
                  bg="transparent" color="green" size="xs"
                  title="تحديد كمكتملة"
                  onClick={() => handleUpdateStatus(item._id, 'completed')}
                >
                  <FiIcons.FiCheck size={20} />
                </Button>
                <Button
                  bg="transparent" color="red.600" size="xs"
                  title="تحديد كفاشلة"
                  onClick={() => handleUpdateStatus(item._id, 'failed')}
                >
                  <FiIcons.FiX size={20} />
                </Button>
              </>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default TransactionsTable;
